module.exports = __webpack_public_path__ + "static/media/arrow-left.c1def0c3.svg";